import { StatusClass, CopyAllHandler } from '@/utils/helpers.js'

export default {
  methods: {
    statusClass (status) {
      return StatusClass(status.toLowerCase())
    },
    handleErrorResponseNotification (error) {
      const err = error.response
        ? error?.response?.data?.error?.publicMessage
        : error
      // only show an error notification if error is not 401
      if (!this.hasEncounteredError401) {
        this.$notify({
          title: this.httpErrorMessage.customMessage,
          message: err || '',
          type: 'error'
        })
      }
      return err
    },
    async getReceiptDetails () {
      const vm = this
      await this.$store
        .dispatch('transactions/getReceiptDetails', this.payload)
        .then(() => {
          this.$refs.DownloadComp.generatePdf()
          this.$notify({
            title: 'Receipt',
            message: 'Transaction Receipt Downloaded Successfully',
            type: 'success'
          })
        })
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.$emit('close')
        })
    },
    async copyAllHandler (depositDetails) {
      await CopyAllHandler(depositDetails, this.$notify)
    }
  },
  computed: {
    pickColor () {
      let colorPicked
      if (this.isDarkMode) {
        colorPicked = this.active ? this.$primaryColor : '#BDBDBD'
      } else {
        colorPicked = this.active ? this.$primaryColor : '#062568'
      }
      return colorPicked
    },
    isDarkMode () {
      return this.$store?.state?.common?.userTheme?.includes('dark-theme')
    },
    httpErrorMessage () {
      return {
        customMessage: this.$store.state.error.error.customMessage,
        backendMessage: this.$store.state.error.error.publicMessage
      }
    },
    hasEncounteredError401 () {
      return this.$store.state.error.hasEncountered401Error
    }
  }
}
